import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { PasswordRegex } from '@/model';
import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

type PasswordCheckProps = {
  password: string;
  regexes: PasswordRegex[];
};

export const PasswordCheck = ({ password, regexes }: PasswordCheckProps) => {
  const { t } = useTranslation();

  return (
    <HStack align='start' gap='micro'>
      <ChakraFeatherIcon name='info' />

      <Box>
        <Text as='span' fontWeight='semibold' color='text.main'>
          {t('components.password_check.password_check_instruction')}
        </Text>

        <Flex direction='column' gap='0.125rem' mt={4}>
          {(regexes || []).map((obj, index) => (
            <Text key={index} color={new RegExp(obj.regex).test(password) ? 'green.500' : 'text.main'}>
              {obj.message}
            </Text>
          ))}
        </Flex>
      </Box>
    </HStack>
  );
};
